import { z } from "zod";

export const ChecklistRelationSchema = z.object({
  id: z.int().positive().readonly(),
  title: z.string().nullable(),
  type: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  order: z.number().min(0).max(2147483647),
  created_at: z.iso.datetime().readonly(),
  updated_at: z.iso.datetime().readonly(),
  creator: z.int().nullable(),
  updater: z.int().nullable(),
  archived: z.boolean(),
  board: z.int(),
  resource: z.int().nullable(),
  client: z.int().nullable(),
  task: z.int().nullable(),
  nudge_date: z.any(), // The [...] in the original model suggests this field might need further definition
  can_edit_grant: z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6)
  ]),
  can_view_grant: z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6)
  ])
});
